export enum TaxRoundingType {
  RoundAwayFromZero = 1,
  RoundToEven = 2,
  Ceiling = 3,
  Floor = 4,
  FloridaPennyTables = 5,
  TaxIncluded = 6
}
export class EffectiveTaxRate {
  taxRate: number;
  taxRoundingType: TaxRoundingType;
  effectiveUtc: Date;
}
